export const black = '#394639';

export const white = '#fff';

export const whiteTransparent = 'rgba(255, 255, 255, 0.7)';

export const lighterGrey = 'rgba(57, 70, 57, 0.04)';

export const lightGrey = 'rgba(57, 70, 57, 0.15)';

export const grey = 'rgba(57, 70, 57, 0.4)';

export const darkGrey = 'rgba(57, 70, 57, 0.65)';

export const lightBrand = '#00eb7a';

export const brand = '#5dc66b';

export const darkBrand = '#00ad5a';

export const brandTransparent = 'rgba(93, 198, 107, 0.1)';

export const lightError = '#ff5252';

export const error = '#ff6c6c';

export const darkError = '#ff3d3d';

export const warning = '#d2c86e';

export const action = '#00a3ff';

export const darkAction = '#0093e5';

export const darkerAction = '#0083cc';

export const green = '#02BF8E';

export const blue = '#007AFF';

const colors = {
  black,
  white,
  whiteTransparent,
  lighterGrey,
  lightGrey,
  grey,
  darkGrey,
  lightBrand,
  brand,
  darkBrand,
  brandTransparent,
  lightError,
  error,
  darkError,
  warning,
  action,
  darkAction,
  darkerAction,
  green,
  blue,
};

export default colors;
